import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Site } from 'solar-bo';
import { SolarService } from '../services/solarservice.service';
import { AppConfig } from '@solar/app.config';

import { SupervisLoadfilesShareData } from '../supervis/supervis-loadfiles/supervis-loadfiles-sharedata';
import { AppInjector } from 'base-models';
import { CompanyTypeEnum } from 'solar-bo';
import { BaseComponent } from '@solar/shared/base.component';
import { PermissionHelper } from './permission-helper.model';

@Component({
  selector: 'app-solar-base1',
  template: ''
})
export class SolarBase1Component extends BaseComponent implements OnInit {

  company_type_std: CompanyTypeEnum;
  company_type_enum = CompanyTypeEnum;//to use in html

  //show section
  public ui_showCompany: boolean = false;


  public solarService: SolarService;

  public constructor() {
    super();
    const injector = AppInjector.getInjector();

    this.solarService = injector.get(SolarService);
    this.company_type_std = this.globService.companyTypeStandard();
    this.configure_show_company();
  }

  ngOnInit() { }

  acl_btn_bysite(button: string, site: Site): boolean {
    try {
      if (this.user && site) {
        let user_acl = this.user.entities_acl;
        let res = PermissionHelper.validateResourceACL(button, site.id, user_acl);
        return res;
      }
      else {
        return false;
      }
    }
    catch (err) {
      console.error(err);
    }
  }

  configure_show_company() {
    if (this.company_type_std == CompanyTypeEnum.VERIFIER) {
      this.ui_showCompany = true;
    }
    else {
      this.ui_showCompany = false;
    }
  }

  newsupervision(site?: Site) {
    this.router.navigateByUrl(AppConfig.ROUTE_SOLAR + "/supervision");
    //this.router.navigate(['site/' , item.id],{relativeTo:this.route});
  }
  showsupervision(item) {
    this.router.navigateByUrl(AppConfig.ROUTE_SOLAR + "/supervision-master/" + item.id);
  }
  showsupervisionedit(item) {
    this.router.navigateByUrl(AppConfig.ROUTE_SOLAR + "/supervisionedit/" + item.id);
  }
  showsupervisionloadfiles(item) {
    SupervisLoadfilesShareData.supervision = item;
    console.log("showsupervisionloadfiles item:", item);
    console.log("SupervisLoadfilesShareData.supervision item:", SupervisLoadfilesShareData.supervision);
    this.router.navigateByUrl(AppConfig.ROUTE_SOLAR + "/supervisionloadfiles/" + item.id);
  }

}